function selectFirstAvailableFrameOption() {
  const frameOptions = document.querySelectorAll(".frame-option");
  if (frameOptions.length > 0) {
    const firstOption = frameOptions[0];
    const firstInput = firstOption.querySelector('input[type="radio"]');
    firstInput.checked = true;
    updateSelectedFrame(firstOption);

    const imgWrapper = firstOption.querySelector(".frame_image-wrapper");
    imgWrapper.style.border = "2px solid black";
  }
}

async function toggleModal() {
  const modal = document.getElementById("PopupModal-popup_product-variant");
  
  if (modal.hasAttribute("open")) {
    modal.removeAttribute("open");
  } else {
    const productHandle = window.location.pathname
      .split("/products/")[1]
      ?.split("?")[0];
      
    try {
      // Fetch product data to check for variants
      const productData = await fetch(`/products/${productHandle}.js`).then(res => res.json());
      
      // Check if product has more than one variant or any option1 value
      if (!productData.options?.[0]?.values?.length || productData.options[0].values.length === 1) {
        console.log("Product doesn't have multiple variants, not showing popup");
        return;
      }
      
      // Proceed with showing modal and fetching data
      const productId = document.querySelector('input[name="product-id"]').value;
      const initialVariantId = document.querySelector('input[name="id"]').value;
      fetchProductAndVariantInfo(productId, initialVariantId);
      setTimeout(() => {
        selectFirstAvailableFrameOption();
      }, 1000);
    } catch (error) {
      console.error("Error checking product variants:", error);
    }
  }
}

// Function to fetch frame collection data
async function fetchFrameCollection() {
  const collectionHandle = "fraame";
  const productsUrl = `/collections/${collectionHandle}/products.json`;

  try {
    const response = await fetch(productsUrl);
    const data = await response.json();

    if (!data.products || data.products.length === 0) {
      throw new Error("No products found in frame collection");
    }

    return data;
  } catch (error) {
    console.error("Error fetching frame collection:", error);
    throw error;
  }
}

async function fetchProductAndVariantInfo(productId, variantId) {
  const modal = document.getElementById("PopupModal-popup_product-variant");
  try {
    const productHandle = window.location.pathname
      .split("/products/")[1]
      ?.split("?")[0];
    if (!productHandle) {
      throw new Error("Product handle not found");
    }

    // Fetch product, frame collection, and framing service data in parallel
    const [productData, frameCollectionData, framingServiceData] =
      await Promise.all([
        fetch(`/products/${productHandle}.js`).then((res) => res.json()),
        fetchFrameCollection(),
        fetch("/products/framing-services.js").then((res) => res.json()),
      ]);

    console.log("Product Data:", productData);
    console.log("Frame Collection:", frameCollectionData);

    if (!productData.variants) {
      throw new Error("Product variants not found");
    }
    const selectedVariant = productData.variants.find(
      (variant) => String(variant.id) === String(variantId)
    );

    if (!selectedVariant) {
      throw new Error(`Variant with ID ${variantId} not found`);
    }

    // Update product info
    document.querySelector(".header_title").textContent = productData.title;
    document.querySelector(".frame-popup__product-image").src =
      productData.featured_image;
    document.querySelector(".product-title-h5").textContent =
      selectedVariant.title;

    // Find matching framing service variant
    const matchingServiceVariant = framingServiceData.variants.find(
      (variant) => variant.title === selectedVariant.options[0]
    );

    // Update framing service checkbox and price if found
    const framingServiceCheckbox = document.querySelector(
      'input[name="framing_service"]'
    );
    const framingServiceLabel = document.querySelector(
      ".frame-popup__service-label"
    );

    if (
      matchingServiceVariant &&
      framingServiceCheckbox &&
      framingServiceLabel
    ) {
      framingServiceCheckbox.setAttribute(
        "data-variant-id",
        matchingServiceVariant.id
      );
      framingServiceCheckbox.setAttribute(
        "data-price",
        matchingServiceVariant.price
      );
      const formattedPrice = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
      }).format(matchingServiceVariant.price / 100);
      framingServiceLabel.textContent = `Framing Service (${formattedPrice})`;
    }

    // Find matching frame product and render frame options
    const frameOptionsContainer = document.querySelector(
      ".frame-popup__variants"
    );
    if (!frameOptionsContainer) {
      throw new Error(
        'Could not find element with class "frame-popup__variants"'
      );
    }

    frameOptionsContainer.innerHTML = ""; // Clear existing options

    const matchingFrameProduct = frameCollectionData.products.find(
      (product) => product.title === selectedVariant.title
    );
    console.log(matchingFrameProduct, "matchingFrameProduct");
    if (matchingFrameProduct) {
      const tempDiv = document.createElement("div");
tempDiv.innerHTML = matchingFrameProduct.body_html;
document.querySelector('.product-description').textContent = tempDiv.textContent || tempDiv.innerText;

      
      modal.setAttribute("open", "");
      matchingFrameProduct.variants.forEach((frameVariant) => {
        const frameOptionHTML = `
              <div class="frame-option-wrapper">
                <label class="frame-option" onclick="updateFrameOption(this)">
                  <input
                    type="radio"
                    id="frame-${frameVariant.id}"
                    name="frame"
                    data-frame-product-id="${matchingFrameProduct.id}"
                    value="${frameVariant.id}"
                    data-price="${frameVariant.price}"
                  >
                  <div class="frame_image-wrapper">
                    <img
                      src="${
                        frameVariant.featured_image?.src ||
                        frameVariant.image?.src
                      }"
                      alt="${matchingFrameProduct.title}"
                      height="100"
                      width="100"
                      class="frame-images"
                    >
                  </div>
                  <div class="frame-name-wrapper">
                    <span class="frame-name">${frameVariant.title}</span>
                    <span class="frame-price">$${frameVariant.price}</span>
                  </div>
                </label>
              </div>
            `;
        frameOptionsContainer.innerHTML += frameOptionHTML;
      });
    }
  } catch (error) {
    // toggleModal()
    console.error("Error fetching product data:", error);
  }
}

async function addToCart(formData) {
  const config = fetchConfig("javascript");
  config.headers["X-Requested-With"] = "XMLHttpRequest";
  delete config.headers["Content-Type"];
  config.body = formData;

  try {
    const response = await fetch(
      window.Shopify.routes.root + "cart/add.js",
      config
    );
    const data = await response.json();

    if (data.status) {
      publish(PUB_SUB_EVENTS.cartError, {
        source: "product-form",
        productVariantId: formData.get("id"),
        errors: data.errors || data.description,
        message: data.message,
      });
      return { error: true, data };
    }

    publish(PUB_SUB_EVENTS.cartUpdate, {
      source: "product-form",
      productVariantId: formData.get("id"),
      cartData: data,
    });

    return { error: false, data };
  } catch (error) {
    console.error("Error:", error);
    publish(PUB_SUB_EVENTS.cartError, {
      source: "product-form",
      productVariantId: formData.get("id"),
      errors: error.message,
    });
    return { error: true, errorMessage: error.message };
  }
}

document.addEventListener("readystatechange", function () {
  const frameOptions = document.querySelectorAll(".frame-option");

  const initialVariantId = document.querySelector('input[name="id"]').value;

  if (frameOptions.length > 0) {
    const firstOption =
      Array.from(frameOptions).find((option) => {
        const input = option.querySelector('input[type="radio"]');
        return input.value === initialVariantId;
      }) || frameOptions[0];

    const firstInput = firstOption.querySelector('input[type="radio"]');
    firstInput.checked = true;
    updateSelectedFrame(firstOption);
  }

  frameOptions.forEach((frameOption) => {
    const input = frameOption.querySelector('input[type="radio"]');

    input.addEventListener("change", () => {
      if (input.checked) {
        updateSelectedFrame(frameOption);
      }
    });
  });

  const addFrameBtn = document.getElementById("addFrameBtn");
  addFrameBtn.addEventListener("click", async () => {
    const packCount = document.querySelector(
      'input[name="properties[pack]"]'
    ).value;
    const selectedFrame = document.querySelector('input[name="frame"]:checked');
    const framingServiceCheckbox = document.querySelector(
      'input[name="framing_service"]'
    );

    if (selectedFrame) {
      const frameId = selectedFrame.value;
      const frameProductId = selectedFrame.getAttribute(
        "data-frame-product-id"
      );
      const quantity = parseInt(packCount) || 1;
      const cartDrawer = document.querySelector("cart-drawer");

      // Show loading state
      addFrameBtn.classList.add("loading");
      addFrameBtn.setAttribute("aria-disabled", true);

      try {
        // Add frame to cart
        const frameFormData = new FormData();
        frameFormData.append("id", frameId);
        frameFormData.append("quantity", quantity);
        frameFormData.append("properties[pack]", packCount);
        frameFormData.append("product-id", frameProductId);
        frameFormData.append("sections", "cart-drawer,cart-icon-bubble");
        frameFormData.append("sections_url", window.location.pathname);

        const frameResult = await addToCart(frameFormData);

        // If framing service is selected, add it to cart
        if (framingServiceCheckbox && framingServiceCheckbox.checked) {
          const framingServiceId =
            framingServiceCheckbox.getAttribute("data-variant-id");

          const serviceFormData = new FormData();
          serviceFormData.append("id", framingServiceId);
          serviceFormData.append("quantity", quantity);
          serviceFormData.append("sections", "cart-drawer,cart-icon-bubble");
          serviceFormData.append("sections_url", window.location.pathname);

          await addToCart(serviceFormData);
        }

        toggleModal();
        if (!frameResult.error) {
          cartDrawer.setActiveElement(document.activeElement);
          cartDrawer.renderContents(frameResult.data);
        } else {
          const soldOutMessage = addFrameBtn.querySelector(".sold-out-message");
          if (soldOutMessage) {
            addFrameBtn.setAttribute("aria-disabled", true);
            soldOutMessage.classList.remove("hidden");
            addFrameBtn.error = true;
          }
        }
      } finally {
        addFrameBtn.classList.remove("loading");
        addFrameBtn.removeAttribute("aria-disabled");
        // addFrameBtn.querySelector(".loading__spinner").classList.add("hidden");
      }
    }
  });

  setTimeout(() => {
    selectFirstAvailableFrameOption();
  }, 1000);
});

function updateSelectedFrame(selectedOption) {
  const selectedImage = document.querySelector(".frame-popup__selectedimage");
  const productId = document.querySelector('input[name="product-id"]').value;
  const allFrameOptions = document.querySelectorAll(".frame-option");

  allFrameOptions.forEach((option) => {
    const optionWrapper = option.querySelector(".frame_image-wrapper");
    optionWrapper.style.border = "2px solid transparent";
  });

  const imgWrapper = selectedOption.querySelector(".frame_image-wrapper");
  imgWrapper.style.border = "2px solid black";

  const selectedImg = imgWrapper.querySelector("img");
  if (selectedImage && selectedImg) {
    selectedImage.src = selectedImg.src;
  }

  // Update hidden variant ID input
  const input = selectedOption.querySelector('input[type="radio"]');
  // document.querySelector('input[name="id"]').value = input.value;

  // Fetch product and variant info
  // fetchProductAndVariantInfo(productId, input.value);
}

function updateFrameOption(frameOption) {
  const frameOptionWrapper = frameOption.closest(".frame-option-wrapper");
  const frameOptionInput = frameOptionWrapper.querySelector(
    'input[type="radio"]'
  );
  frameOptionInput.checked = true;
  updateSelectedFrame(frameOption);
}
